module.exports = __webpack_public_path__ + "img/160x130.ed2337b6.png";